import { ITreatmentDto } from '../model/ITreatmentDto';
import { axiosMod, getPublicApiUrl } from '../utility';

export interface ITreatmentApi {
  getById(id: number): Promise<ITreatmentDto>;
}

export class TreatmentApi implements ITreatmentApi {
  private endpointUrl: string;

  constructor() {
    this.endpointUrl = getPublicApiUrl('/treatment');
  }

  async getById(id: number): Promise<ITreatmentDto> {
    const response = await axiosMod().get<ITreatmentDto>(
      `${this.endpointUrl}/${id}`
    );

    return response.data;
  }
}
